import { ShiftAuthRequestError } from '../services/auth/shift-auth.service';

export const resolveLoginErrorMessage = (requestError: unknown): string => {
  if (requestError instanceof ShiftAuthRequestError) {
    if (requestError.isNetworkError) {
      return 'אין תקשורת לשרת ההתחברות. ודאו שה-backend רץ על http://localhost:5000.';
    }

    if (requestError.status === 400) {
      return requestError.message || 'בקשת ההתחברות לא תקינה.';
    }

    if (requestError.status === 401) {
      return 'שם המשתמש או הסיסמה שגויים.';
    }

    if (requestError.status === 403) {
      return 'הגישה נחסמה עבור המשתמש הזה. פנו למנהל המערכת.';
    }

    if (requestError.status === 429) {
      return 'בוצעו יותר מדי ניסיונות התחברות. נסו שוב בעוד דקה.';
    }

    if (requestError.status >= 500) {
      return 'אירעה שגיאה בשרת. נסו שוב.';
    }

    return requestError.message || 'Login failed';
  }

  return 'אירעה שגיאה לא צפויה. נסו שוב.';
};

export const resolveRequestErrorMessage = (requestError: unknown, fallbackMessage: string): string => {
  if (requestError instanceof ShiftAuthRequestError) {
    if (requestError.isNetworkError) {
      return 'אין תקשורת לשרת. ודאו שה-backend רץ על http://localhost:5000.';
    }

    return requestError.message || fallbackMessage;
  }

  return fallbackMessage;
};
